import { FC, useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { withStyles } from 'vopay';
import { UtilButton } from 'UI';
import styles from './ExpandableText.module.scss';

const cn = withStyles(styles);

type ExpandableTextProps = {
  text: string;
  collapsedHeight?: number;
};

const ExpandableText: FC<ExpandableTextProps> = ({ text, collapsedHeight = 26 }) => {
  const { t } = useTranslation('translations', { keyPrefix: 'UI.ExpandableText' });
  const [expanded, setExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [fullHeight, setFullHeight] = useState(0);
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = textRef.current;
    if (!el) return;

    setFullHeight(el.scrollHeight);
    setIsOverflowing(el.scrollHeight > collapsedHeight);
  }, [text]);

  return (
    <div className={cn('container', expanded && 'expanded')}>
      <div
        ref={textRef}
        className={cn('description')}
        style={{
          height: expanded ? fullHeight : collapsedHeight,
        }}
      >
        {text}
        {!expanded && isOverflowing && <span>...</span>}
      </div>

      {isOverflowing && (
        <UtilButton onClick={() => setExpanded(!expanded)}>
          {expanded ? t('showLess', { defaultValue: 'Show less' }) : t('showMore', { defaultValue: 'Show more' })}
        </UtilButton>
      )}
    </div>
  );
};

export default ExpandableText;
